import React, { useEffect } from 'react';
import { TLCode } from '../../../common/enums';
import { useProgressionDialogState, ProgressionDialog } from './ProgressionsDialog';
import { Translate } from '../WithTranslate';

interface RefreshGeoDataDialogProps {
  translate: Translate;
  inProgress: boolean;
  inError: boolean;
  done: boolean;
  onClose?: () => void;
}

export const RefreshGeoDataDialog = ({ translate, inProgress, inError, done, onClose }: RefreshGeoDataDialogProps) => {
  const progressionDialogState = useProgressionDialogState();

  const doneText = translate(TLCode.REFRESH_GEO_DATA_Done);
  const errorText = translate(TLCode.REFRESH_GEO_DATA_Error);
  const titleText = translate(TLCode.REFRESH_GEO_DATA_Title);
  const closeButtonText = translate(TLCode.Close);

  useEffect(() => {
    if (inProgress) progressionDialogState.setInProgress();
  }, [inProgress, progressionDialogState.setInProgress]);

  useEffect(() => {
    if (inError) progressionDialogState.setInError();
  }, [inError, progressionDialogState.setInError]);

  useEffect(() => {
    if (done) progressionDialogState.setDone();
  }, [done, progressionDialogState.setDone]);

  return (
    <ProgressionDialog
      inProgress={progressionDialogState.inProgress}
      inError={progressionDialogState.inError}
      done={progressionDialogState.done}
      titleText={titleText}
      doneText={doneText}
      errorText={errorText}
      closeButtonText={closeButtonText}
      onClose={() => {
        if (onClose) onClose();
        progressionDialogState.reset();
      }}
    />
  );
};
